import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import CommonState from '@/class/cargo/model/parameters/CommonState'
import {
  FIELD_DROP_DOWN_LIST,
  FIELD_TEXT,
  FIELD_USER,
  OPERATOR_EQUAL
} from '@/class/cargo/model/utils/AdvancedSearchConsts'

function toCommonStates(options) {
  return (options || []).map(item => new CommonState(item.value, item.label, item.label))
}

export function createTextSearchField(label, fieldName) {
  const searchField = new AdvancedSearchField()
  searchField.action = AdvancedSearchField.ADD_ACTION
  searchField.itemType = 'input'
  searchField.multiple = 0
  searchField.defaultValue = ''
  searchField.itemLabel = label
  searchField.itemName = fieldName
  searchField.fieldType = FIELD_TEXT
  searchField.itemCondition = [OPERATOR_EQUAL]
  searchField.defaultConditionVal = OPERATOR_EQUAL.code
  searchField.defaultSelected = 1
  searchField.selected = 1
  return searchField.formatObj2Json()
}

export function createSelectSearchField(label, fieldName, options) {
  const searchField = new AdvancedSearchField()
  searchField.action = AdvancedSearchField.ADD_ACTION
  searchField.itemType = 'select'
  searchField.multiple = 0
  searchField.defaultValue = ''
  searchField.itemLabel = label
  searchField.itemName = fieldName
  searchField.fieldType = FIELD_DROP_DOWN_LIST
  searchField.itemCondition = [OPERATOR_EQUAL]
  searchField.defaultConditionVal = OPERATOR_EQUAL.code
  searchField.defaultSelected = 1
  searchField.selected = 1
  searchField.dataProvider = toCommonStates(options)
  return searchField.formatObj2Json()
}

/** 人员下拉：输入关键字匹配，值为 userId */
export function createUserSearchField(label, fieldName) {
  const searchField = new AdvancedSearchField()
  searchField.action = AdvancedSearchField.ADD_ACTION
  searchField.itemType = 'allUser'
  searchField.multiple = 0
  searchField.defaultValue = ''
  searchField.itemLabel = label
  searchField.itemName = fieldName
  searchField.fieldType = FIELD_USER
  searchField.itemCondition = [OPERATOR_EQUAL]
  searchField.defaultConditionVal = OPERATOR_EQUAL.code
  searchField.defaultSelected = 1
  searchField.selected = 1
  searchField.itemValue = ''
  searchField.lock = false
  return searchField.formatObj2Json()
}

export function initLocalSearchItem(searchItem) {
  if (!searchItem || !searchItem.fillGlobalConfig) return
  searchItem.defaultSearchItems = []
  searchItem.fillGlobalConfig()
}

export function applySearchConditions(filter, conditions, fieldNames) {
  fieldNames.forEach(fieldName => {
    const condition = (conditions || []).find(item => item.fieldName === fieldName)
    if (!condition || condition.value === null || typeof condition.value === 'undefined') {
      filter[fieldName] = ''
      return
    }
    if (Array.isArray(condition.value)) {
      filter[fieldName] = condition.value[0] || ''
      return
    }
    filter[fieldName] = condition.value === '' ? '' : String(condition.value)
  })
}
